import axios from "axios";
import { captureMessage } from "logrocket";

/**
 * Helper for LogRocket error reporting with environment checks
 * Falls back to console.log in development or when LogRocket is disabled
 */
export function captureErrorMessage(...props: Parameters<typeof captureMessage>): void {
  const [message, options] = props;
  const isLogRocketEnabled = process.env.REACT_APP_ENABLE_LOG_ROCKET === "true";
  const isDevelopment = process.env.NODE_ENV === "development";

  if (!isLogRocketEnabled || isDevelopment) {
    // Use console.log in development or when LogRocket is disabled
    const tags = options?.tags ? ` | Tags: ${JSON.stringify(options.tags)}` : "";
    console.log(`[LogRocket] ${message}${tags}`);

    return;
  }

  captureMessage(message, options);
}

type ParseErrorProps = {
  error: unknown;
  fallback?: string;
};

export const parseError = ({ error, fallback = "Unknown error" }: ParseErrorProps) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    const statusText = error.response?.statusText;

    // Prefer clean "status statusText" format when available
    if (status && statusText) {
      return `${status} ${statusText}`;
    }

    // Fall back to the error message to avoid duplication
    // (Axios messages typically include status already)
    return error.message;
  }

  return error instanceof Error ? error.message : fallback;
};
